import { platformApiFetch } from './platformClient';

export interface PlatformAdminInfo {
  id: string;
  name: string;
  email: string;
}

export function platformLogin(email: string, password: string): Promise<{ admin: PlatformAdminInfo }> {
  return platformApiFetch<{ admin: PlatformAdminInfo }>('/super_admin/auth/login', {
    method: 'POST',
    body: JSON.stringify({ email, password }),
  });
}

export function platformLogout(): Promise<{ ok: boolean }> {
  return platformApiFetch<{ ok: boolean }>('/super_admin/auth/logout', { method: 'POST' });
}

export function getPlatformMe(): Promise<PlatformAdminInfo> {
  return platformApiFetch<PlatformAdminInfo>('/super_admin/auth/me');
}
